<h2 mat-dialog-title>{{ 'orders.confirmHistoricalSubmission' | transloco }}</h2>
<mat-dialog-content>{{ 'orders.areYouSureYouReReady' | transloco }}</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close color="accent" [mat-dialog-close]="{ submit: false }"
        data-testid="negative-dialog-button">{{ 'common.buttons.close' | transloco }}</button>
    <span class="spacer"></span>
    <button mat-button mat-dialog-close color="accent" [mat-dialog-close]="{ submit: true }"
        data-testid="positive-dialog-button">{{ 'common.buttons.save' | transloco }}</button>
</mat-dialog-actions>